(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  function progress() {
    if (document.querySelector('.lb-progress')) return;
    var bar = document.createElement('div'); bar.className = 'lb-progress'; document.body.appendChild(bar);
    var tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.setProperty('--lb-prog', h > 0 ? (window.scrollY / h).toFixed(4) : 0);
        tick = false;
      });
    }, { passive: true });
  }

  function announce(root) {
    (root || document).querySelectorAll('[data-lb-announce]').forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var items = bar.querySelectorAll('.lb-announce__item'); if (items.length < 2) { if (items[0]) items[0].classList.add('is-on'); return; }
      var i = 0; items[0].classList.add('is-on');
      var t = parseInt(bar.dataset.speed || '4', 10) * 1000;
      setInterval(function () {
        var a = items[i]; i = (i + 1) % items.length; var b = items[i];
        a.classList.remove('is-on'); a.classList.add('is-out');
        b.classList.remove('is-out'); b.classList.add('is-on');
        setTimeout(function () { a.classList.remove('is-out'); }, 650);
      }, t);
    });
  }

  function embers(root) {
    if (reduce) return;
    (root || document).querySelectorAll('.lb-hero').forEach(function (hero) {
      if (hero.dataset.embers) return; hero.dataset.embers = '1';
      var c = document.createElement('canvas'); c.className = 'lb-embers'; hero.prepend(c);
      if (fine) { var g = document.createElement('div'); g.className = 'lb-cursor-glow'; hero.prepend(g);
        hero.addEventListener('pointermove', function (e) { var r = hero.getBoundingClientRect(); g.style.setProperty('--gx', (e.clientX - r.left) + 'px'); g.style.setProperty('--gy', (e.clientY - r.top) + 'px'); }); }
      var ctx = c.getContext('2d'), W, H, dpr = Math.min(window.devicePixelRatio || 1, 2), ps = [], run = true;
      function size() { W = hero.offsetWidth; H = hero.offsetHeight; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      function spawn() { return { x: Math.random() * W, y: H + Math.random() * 40, r: Math.random() * 2.2 + .6, vy: -(Math.random() * .6 + .25), vx: (Math.random() - .5) * .3, life: 0, max: 260 + Math.random() * 260, h: 20 + Math.random() * 25 }; }
      size(); window.addEventListener('resize', size);
      var n = W < 700 ? 26 : 55; for (var k = 0; k < n; k++) { var p = spawn(); p.y = Math.random() * H; ps.push(p); }
      new IntersectionObserver(function (es) { run = es[0].isIntersecting; if (run) loop(); }).observe(hero);
      function loop() {
        if (!run) return;
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < ps.length; i++) {
          var p = ps[i]; p.life++; p.x += p.vx + Math.sin((p.life + i * 20) / 40) * .25; p.y += p.vy;
          var a = Math.sin(Math.PI * Math.min(p.life / p.max, 1));
          ctx.beginPath(); ctx.fillStyle = 'hsla(' + p.h + ',100%,62%,' + (a * .75).toFixed(3) + ')';
          ctx.shadowColor = 'hsla(' + p.h + ',100%,60%,.9)'; ctx.shadowBlur = 8;
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
          if (p.life > p.max || p.y < -10) ps[i] = spawn();
        }
        requestAnimationFrame(loop);
      }
    });
  }

  function spotlight(root) {
    if (!fine) return;
    (root || document).querySelectorAll('.lb-card, .lb-step').forEach(function (el) {
      if (el.dataset.spot) return; el.dataset.spot = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        el.style.setProperty('--mx', x + 'px'); el.style.setProperty('--my', y + 'px');
        if (!reduce) el.style.transform = 'perspective(900px) rotateX(' + ((y / r.height - .5) * -5).toFixed(2) + 'deg) rotateY(' + ((x / r.width - .5) * 5).toFixed(2) + 'deg) translateY(-4px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function demo(root) {
    (root || document).querySelectorAll('[data-lb-demo]').forEach(function (d) {
      if (d.dataset.ready) return; d.dataset.ready = '1';
      var note = d.querySelector('.lb-remote__note'), hudC = d.querySelector('[data-hud-color]'), hudM = d.querySelector('[data-hud-mode]'), hudT = d.querySelector('[data-hud-timer]');
      var power = d.querySelector('.lb-power'), cName = d.querySelector('[data-color-name]'), timer = null, left = 0;
      function setColor(b) {
        d.querySelectorAll('.lb-swatch').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        d.style.setProperty('--lb-cur', b.dataset.color);
        if (hudC) hudC.textContent = b.dataset.name; if (cName) cName.textContent = b.dataset.name;
        if (note && b.dataset.text) note.textContent = b.dataset.text;
      }
      d.querySelectorAll('.lb-swatch').forEach(function (b) { b.addEventListener('click', function () { if (d.dataset.on === 'false') togglePower(true); setColor(b); }); });
      var first = d.querySelector('.lb-swatch'); if (first) setColor(first);
      d.querySelectorAll('[data-mode-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          d.querySelectorAll('[data-mode-btn]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          d.dataset.mode = b.dataset.modeBtn; if (hudM) hudM.textContent = b.textContent.trim();
          if (d.dataset.on === 'false') togglePower(true);
        });
      });
      function fmt(s) { var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60; return h + ':' + String(m).padStart(2, '0') + ':' + String(x).padStart(2, '0'); }
      d.querySelectorAll('[data-timer-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          d.querySelectorAll('[data-timer-btn]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          clearInterval(timer); var h = parseInt(b.dataset.timerBtn, 10);
          if (!h) { if (hudT) hudT.textContent = '—'; return; }
          if (d.dataset.on === 'false') togglePower(true);
          left = h * 3600; if (hudT) hudT.textContent = fmt(left);
          timer = setInterval(function () { left -= 1; if (hudT) hudT.textContent = fmt(Math.max(left, 0)); if (left <= 0) { clearInterval(timer); togglePower(false); } }, 1000);
        });
      });
      function togglePower(on) {
        d.dataset.on = on ? 'true' : 'false'; if (power) power.setAttribute('aria-pressed', on ? 'true' : 'false');
        var lbl = power && power.querySelector('[data-power-label]'); if (lbl) lbl.textContent = on ? lbl.dataset.on : lbl.dataset.off;
        if (!on) clearInterval(timer);
      }
      if (power) power.addEventListener('click', function () { togglePower(d.dataset.on === 'false'); });
    });
  }

  function stats(root) {
    var els = (root || document).querySelectorAll('[data-lb-count]:not([data-done])');
    if (!els.length) return;
    function run(el) {
      el.dataset.done = '1'; var to = parseFloat(el.dataset.lbCount) || 0, dur = 1600, t0 = null;
      if (reduce || to === 0) { el.textContent = el.dataset.lbCount; return; }
      function step(t) { if (!t0) t0 = t; var k = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(to * e); if (k < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }); }, { threshold: .4 });
    els.forEach(function (el) { el.textContent = '0'; io.observe(el); });
  }

  function quiz(root) {
    (root || document).querySelectorAll('[data-lb-quiz]').forEach(function (q) {
      if (q.dataset.ready) return; q.dataset.ready = '1';
      var res = q.querySelector('.lb-quiz__res'), nm = q.querySelector('.lb-quiz__name'), tx = q.querySelector('.lb-quiz__txt'), tg = q.querySelector('.lb-quiz__tags'), k = q.querySelector('.lb-quiz__k');
      q.querySelectorAll('.lb-qopt').forEach(function (b) {
        b.addEventListener('click', function () {
          q.querySelectorAll('.lb-qopt').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          res.style.setProperty('--c', b.dataset.color);
          if (k) k.textContent = b.dataset.kicker; nm.textContent = b.dataset.aroma; tx.textContent = b.dataset.text;
          tg.innerHTML = ''; (b.dataset.tags || '').split('|').forEach(function (t) { t = t.trim(); if (!t) return; var s = document.createElement('span'); s.textContent = t; tg.appendChild(s); });
          res.classList.remove('is-swap'); void res.offsetWidth; res.classList.add('is-swap');
        });
      });
      var f = q.querySelector('.lb-qopt'); if (f) f.click();
    });
  }

  function addBusinessDays(d, n) { var r = new Date(d); var added = 0; while (added < n) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) added++; } return r; }
  function eta(root) {
    (root || document).querySelectorAll('[data-lb-eta]').forEach(function (el) {
      var now = new Date(), f = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short' });
      var p = parseInt(el.dataset.prep || '2', 10), a = parseInt(el.dataset.min || '7', 10), b = parseInt(el.dataset.max || '12', 10);
      var ship = addBusinessDays(now, p), d1 = addBusinessDays(ship, a), d2 = addBusinessDays(ship, Math.max(a, b));
      var set = function (sel, v) { el.querySelectorAll(sel).forEach(function (x) { x.textContent = v; }); };
      set('[data-eta-today]', 'Hoy'); set('[data-eta-ship]', f.format(ship));
      set('[data-eta-range]', f.format(d1) + ' y el ' + f.format(d2));
      var last = el.querySelector('.lb-eta__step:last-child [data-eta-range]'); if (last) last.textContent = f.format(d1) + ' – ' + f.format(d2);
    });
  }

  function zoom(root) {
    (root || document).querySelectorAll('[data-lb-gallery]').forEach(function (g) {
      if (g.dataset.zoom) return; g.dataset.zoom = '1';
      var main = g.querySelector('.lb-gallery__main'); if (!main) return;
      main.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        var img = main.querySelector('.lb-gallery__slide.is-active img'); if (!img) return;
        var z = document.createElement('div'); z.className = 'lb-zoom'; z.setAttribute('role', 'dialog'); z.setAttribute('aria-label', 'Foto ampliada');
        var big = document.createElement('img'); big.src = img.currentSrc || img.src; big.alt = img.alt;
        var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Cerrar'); x.textContent = '×';
        z.appendChild(big); z.appendChild(x); document.body.appendChild(z);
        requestAnimationFrame(function () { z.classList.add('is-on'); });
        function close() { z.classList.remove('is-on'); setTimeout(function () { z.remove(); }, 350); document.removeEventListener('keydown', esc); }
        function esc(ev) { if (ev.key === 'Escape') close(); }
        z.addEventListener('click', function (ev) { if (ev.target !== big) close(); }); document.addEventListener('keydown', esc); x.focus();
      });
    });
  }

  function track(root) {
    (root || document).querySelectorAll('[data-lb-track]').forEach(function (f) {
      if (f.dataset.ready) return; f.dataset.ready = '1';
      f.addEventListener('submit', function (e) {
        e.preventDefault(); var v = (f.querySelector('input').value || '').trim().replace(/\s+/g, '');
        if (!v) return; window.open('https://t.17track.net/es#nums=' + encodeURIComponent(v), '_blank', 'noopener');
      });
    });
  }

  function withdraw(root) {
    (root || document).querySelectorAll('[data-lb-withdraw]').forEach(function (w) {
      if (w.dataset.ready) return; w.dataset.ready = '1';
      var s1 = w.querySelector('[data-step="1"]'), s2 = w.querySelector('[data-step="2"]'), sum = w.querySelector('.lb-wd__sum'), err = w.querySelector('[data-step="1"] .lb-wd__err');
      var next = w.querySelector('[data-next]'), back = w.querySelector('[data-back]');
      if (!s1 || !s2) return;
      next.addEventListener('click', function () {
        var ok = true, lines = [];
        s1.querySelectorAll('input[required], textarea[required]').forEach(function (i) { if (!i.value.trim()) ok = false; });
        var em = s1.querySelector('input[type="email"]'); if (em && em.value && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value)) ok = false;
        if (!ok) { err.hidden = false; return; } err.hidden = true;
        s1.querySelectorAll('[data-label]').forEach(function (i) { if (i.value.trim()) lines.push('<b>' + i.dataset.label + ':</b> ' + i.value.replace(/[<>&]/g, '')); });
        var stamp = w.querySelector('input[name="contact[Fecha de la solicitud]"]'); if (stamp) stamp.value = new Date().toLocaleString('es-ES');
        sum.innerHTML = lines.join('<br>'); s1.hidden = true; s2.hidden = false; s2.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      back.addEventListener('click', function () { s2.hidden = true; s1.hidden = false; });
    });
  }

  function init(root) { announce(root); embers(root); spotlight(root); demo(root); stats(root); quiz(root); eta(root); zoom(root); track(root); withdraw(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { progress(); init(); });
  else { progress(); init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();